import styled, {css} from 'styled-components';
import Lottie from 'lottie-react';
import ChekinProSettings from '../../ChekinProSettings';
import {DEVICE, transformSizePropToSize} from '@chekin/guestapp-ui-kit';
import {getIsSDKLimitedMode} from '../../utils/sdk';
import {Popup} from '@guestapp/old-ui-kit';

type ModalProps = {
  zIndex?: number | string;
  maxWidth?: number | string;
  width?: number | string;
};

export const ModalStyled = styled(Popup)<ModalProps>`
  @keyframes anvil {
    0% {
      transform: scale(1) translateY(0px);
      opacity: 0;
      box-shadow: 0 0 0 rgba(241, 241, 241, 0);
    }
    1% {
      transform: scale(0.96) translateY(10px);
      opacity: 0;
      box-shadow: 0 0 0 rgba(241, 241, 241, 0);
    }
    100% {
      transform: scale(1) translateY(0px);
      opacity: 1;
      box-shadow: 0 0 500px rgba(241, 241, 241, 0);
    }
  }

  @keyframes overlay {
    0% {
      opacity: 0;
      box-shadow: 0 0 0 rgba(241, 241, 241, 0);
    }
    100% {
      opacity: 1;
      box-shadow: 0 0 500px rgba(241, 241, 241, 0);
    }
  }

  &-overlay {
    z-index: ${props => props.zIndex || 999};
    animation: overlay 0.3s forwards;
    -webkit-animation: overlay 0.3s forwards;
    background: rgba(16, 16, 16, 0.3);

    @media only screen and (min-width: ${DEVICE.mobileXL}) and (max-height: 601px) {
      overflow: scroll;
    }
  }

  &-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    overflow-y: auto;
    min-width: auto;
    width: 100%;
    height: ${() => {
      return ChekinProSettings.autoHeight ? 'initial' : '100%';
    }};
    padding: 40px 24px;
    border: none;
    text-align: center;
    background: var(--background-boxes-modals);
    animation: anvil 0.3s forwards;
    -webkit-animation: anvil 0.3s forwards;

    & .modal__close-btn {
      & path {
        stroke: var(--font-primary);
      }
    }
    @media (min-width: ${DEVICE.mobileXL}) {
      height: auto;
      width: ${props => transformSizePropToSize(props.width) || 'auto'};
      max-width: ${props => transformSizePropToSize(props.maxWidth) || '500px'};
      min-width: 306px;
      border-radius: 16px;
      padding: 48px 24px;
      min-height: 305px;
    }

    ${() => {
      if (!getIsSDKLimitedMode()) {
        return css`
          @media (min-width: ${DEVICE.laptop}) {
            left: 125px;
          }
        `;
      }
    }};

    ${() => {
      if (ChekinProSettings.autoHeight) {
        return css`
          margin-top: 50px !important;
        `;
      }
    }};

    @media only screen and (min-width: ${DEVICE.mobileXL}) and (max-height: 601px) {
      top: 6%;
      max-width: ${props => props.maxWidth || '530px'};
    }
  }
`;

export const IconWrapper = styled.div`
  text-align: center;
  user-select: none;
  display: flex;
  margin: 0 auto;
`;

export const Title = styled.div`
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  padding: 0 10px;
  color: var(--font-primary);
  cursor: default;
  margin: 0 auto 0;
  font-family: var(--title-font-family);
`;

export const Text = styled.div`
  font-weight: 400;
  color: var(--font-primary, #152946);
  font-size: 16px;
  word-break: break-word;
  margin: 0 auto 0;
  box-sizing: border-box;
  text-align: center;
  cursor: default;

  & > b {
    font-weight: 400;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  top: 16px;
  right: 16px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

export const StyledLottie = styled(Lottie)`
  width: 149px;
  height: 149px;
  margin: 0 auto;

  body[data-layout-mode='kiosko'] & {
    width: 352px;
    height: 352px;
  }
`;
